<template>
    <div id="Grade">
        <div
            v-if="orderData.length > 0"
            style="font-size: 16px; padding: 10px 20px"
        >
            您当前有<span style="color: #0979c5">{{ orderData.length }}</span>个订单的班级（{{
                orderData[0].orderClassStudents[0].className
            }}等）还
            <span style="color: #0979c5">未支付</span>
            ，您可前往
            <router-link :to="{ path: '/order' }">我的订单</router-link>
            进行缴费或取消。
        </div>
        <div style="height: 10px; background: #eff2fa"></div>
        <el-tabs type="card">
            <el-tab-pane :label="activenames">
                <div>
                    <div class="pay-tip">
                        <img
                            src="../../../assets/images/icon/tip.png"
                            alt=""
                        />
                        <div>
                            <div>
                                1.未缴费班级请在规定时间内及时缴费，超时会取消您的报名资格哦。
                            </div>
                            <div>
                                2.若还想继续选择班级，可点击“继续选报班级”进入选择班级界面。
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="RecordData"
                        ref="CourseData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        v-loading="loading"
                        @selection-change="handleSelectionChange"
                        element-loading-text="数据加载中，请稍等..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                    >
                        <el-table-column
                            type="selection"
                            fixed="left"
                        ></el-table-column>
                        <el-table-column
                            prop="className"
                            label="班级"
                            fixed="left"
                            show-overflow-tooltip
                            min-width="180"
                        >
                            <template slot-scope="scope">
                                <div>
                                    {{ scope.row.className
                                    }}<span
                                        v-if="scope.row.isShortTraining"
                                        style="color: #e4393c; font-size: 14px"
                                    >(短训班)</span>
                                </div>
                                <div
                                    style="color: #e4393c"
                                    v-if="scope.row.lastPayTime"
                                >
                                    请{{ scope.row.lastPayTime }}前缴费
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="periodName"
                            label="上课教室时段"
                            min-width="180"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.isShortTraining">
                                    <el-tooltip
                                        :content="scope.row.$customClassName"
                                        placement="right"
                                    >
                                        <span>{{
                                                scope.row.shortTrainingStart
                                            }}到{{
                                                scope.row.shortTrainingEnd
                                            }}</span>
                                    </el-tooltip>
                                </span>
                                <span v-else>{{
                                    scope.row.$customClassName
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="teacherName"
                            label="老师"
                            show-overflow-tooltip
                            min-width="100"
                        ></el-table-column>
                        <el-table-column
                            prop="fee"
                            label="学费/元"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="materialCost"
                            label="材料费/元"
                            show-overflow-tooltip
                            v-if="ismast"
                        ></el-table-column>
                        <el-table-column
                            prop="entryFee"
                            label="报名费/元"
                            show-overflow-tooltip
                            v-if="isbm"
                        ></el-table-column>
                        <el-table-column
                            prop="ageRemissionMoney"
                            label="年龄折扣/元"
                            show-overflow-tooltip
                            v-if="agediscount"
                        >
                            <template slot-scope="scope">
                                <span v-if="!scope.row.ageRemissionMoney">
                                    0
                                </span>
                                <span v-else>
                                    {{ scope.row.ageRemissionMoney }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            fixed="right"
                            min-width="200"
                        >
                            <template slot-scope="scope">
                                <!-- <el-button @click="showdetails('classmembers',scope.row)" v-if="scope.row.half">{{scope.row.half}}减免</el-button> -->
                                <el-button @click="quit(scope.row)">退班</el-button>
                                <span v-if="
                                        (scope.row.half === 0 || scope.row.half) && scope.row.fee > 0
                                    ">
                                    <el-button
                                        @click="agereduce(scope.row)"
                                        v-if="
                                            !scope.row.ishalf &&
                                            !scope.row.halveFalg
                                        "
                                    >{{ scope.row.half }}减免</el-button>
                                    <el-button
                                        type="primary"
                                        @click="cancelreduce(scope.row)"
                                        v-if="
                                            scope.row.ishalf &&
                                            !scope.row.halveFalg
                                        "
                                    >{{ scope.row.half }}减免</el-button>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="table-footer">
                        <div
                            class="f-choose"
                            @click="chooseclass"
                        >
                            继续选报班级>>
                        </div>
                        <div class="f-footer">
                            <div>
                                已选择班级<span>{{ classdata.length }}</span>个
                            </div>
                            <!-- <div>合计 <span>600</span></div> -->
                            <el-button
                                type="primary"
                                @click="gopay"
                            >去缴费</el-button>
                        </div>
                    </div>
                    <div class="wrap_footer clearfix">
                        <div class="right">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageIndex"
                                :page-sizes="[10, 15, 20, 25]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                            ></el-pagination>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- 班级详情弹出层 -->
    </div>
</template>

<script>
export default {
    name: "Grade",
    props: ["tabindex"],
    created () {
        let me = this;
    },
    data () {
        return {
            activenames: "我要缴费",
            classdata: [],
            //  总页数
            total: 0,
            loading: false,
            agediscount: false,
            ismast: false,
            isbm: false,
            //  当前页
            pageIndex: 1,
            pageSize: 10,
            RecordData: [],
            mainData: [],
            orderForm: {
                termId: "",
                payStatus: 1,
                startTime: "",
                endTime: "",
                pageIndex: 1,
                pageSize: 5,
            },
            rhalfId: [],
            gopayForm: {
                ids: [],
                termId: "",
                halfId: "",
            },
            orderData: [],
            query: {
                className: "",
                termId: "",
                affirmed: "0",
                studentId: "",
                status: [1],
                pageIndex: "1",
                pageSize: "999",
            },
        };
    },
    async mounted () {
        let me = this;
        me.gopayForm = {
            ids: [],
            termId: "",
            halfId: "",
        };
        me.rhalfId = [];
        let userinfo = window.sessionStorage.getItem("userinfo");
        userinfo = JSON.parse(userinfo);
        me.query.studentId = userinfo.id;
        this.classdata = [];
        await me.getTerm();
        // await me.queryclass();
    },
    watch: {},

    methods: {
        cancelreduce (row) {
            let me = this;
            row.ishalf = false;
            row.ageRemissionMoney = null;
            this.rhalfId.forEach(function (item, index) {
                if (row.id == item) {
                    me.rhalfId.splice(index, 1);
                }
            });
        },
        async getRealNameRecord () {
            let that = this;
            let res = await this.$userService.getRealNameRecord();
            if (res.success) {
                if (res.content) {
                    if (res.content.status == "2") {
                        that.gopay();
                    } else {
                        me.$router.push({ name: "verifyStatus" });
                    }
                } else {
                    me.$router.push({ name: "verify" });
                }
            }
        },
        async checkNeedAuth () {
            let that = this;
            let res = this.$userService.checkNeedAuth();
            if (res.success) {
                if (res.content.isAttestation) {
                    that.getRealNameRecord();
                } else {
                    that.gopay();
                }
            }
        },
        async agereduce (row) {
            let me = this;

            let param = {
                termId: "",
                studentId: "",
                halfId: [],
                lastHalfId: "",
            };
            param.studentId = me.query.studentId;
            param.termId = me.gopayForm.termId;
            me.rhalfId.push(row.id);
            param.lastHalfId = row.id;
            param.halfId = me.rhalfId;
            let res = await me.$team.checkHalf(param);
            if (res && res.success) {
                if (res.content.isCan) {
                    me.rhalfId = param.halfId;
                    row.ageRemissionMoney = res.content.money;
                    me.rhalfId.forEach(function (items, indexs) {
                        me.RecordData.forEach(function (item, index) {
                            if (item.id == items) {
                                me.agediscount = true;
                                item.ishalf = true;
                            }
                        });
                    });
                } else {
                    me.rhalfId.splice(me.rhalfId.length - 1, 1);

                    me.$message({
                        message: "您的减免次数已达上限，无法减免",
                        type: "success",
                    });
                }
            } else {
                me.rhalfId.splice(me.rhalfId.length - 1, 1);

                me.$message({
                    message: "您的减免次数已达上限，无法减免",
                    type: "success",
                });
            }
        },
        async quit (row) {
            let me = this,
                param = {
                    id: me.query.studentId,
                    classStudentIds: [],
                };
            param.classStudentIds.push(row.id);
            let res = await me.$userService.quitClass(param);
            if (res && res["success"]) {
                me.$message({
                    message: "退班成功",
                    type: "success",
                });
                let index = this.RecordData.indexOf(row);
                this.rhalfId.forEach(function (item, index) {
                    if (row.id == item) {
                        me.rhalfId.splice(index, 1);
                    }
                });
                this.RecordData.splice(index, 1);
            }
        },
        async queryOrder () {
            let me = this,
                param = me.orderForm;
            let res = await me.$userService.queryOrder(param);
            if (res && res["success"]) {
                me.orderData = res.content.records;
            }
        },
        async getTerm () {
            let me = this,
                param = {
                    type: "1",
                    planType: "1",
                };
            let res = await me.$userService.select(param);
            if (res && res["success"]) {
                me.orderForm.termId = res.content.term.id;
                me.gopayForm.termId = res.content.term.id;
                me.query.termId = res.content.term.id;
                me.queryOrder();
                await me.queryClassStudent();
            }
        },
        handleSelectionChange (val) {
            this.classdata = [];
            this.classdata = val;
        },
        chooseclass () {
            this.$router.push({ name: "register" });
        },
        async gopay () {
            let me = this;
            if (this.classdata.length > 0) {
                me.gopayForm.ids = [];
                this.classdata.forEach(function (item, idex) {
                    me.gopayForm.ids.push(item.id);
                });
                this.gopayForm.halfId = this.rhalfId;
                let param = this.gopayForm;
                let res = await me.$userService.travelToPay(param);
                if (res && res["success"]) {
                    me.$router.push({
                        name: "Confirm",
                        params: {
                            param: JSON.stringify(res.content),
                        },
                    });
                    me.gopayForm.halfId = [];
                    me.rhalfId = [];
                } else {
                    me.$alert(`<strong style="color: red;font-size: 16px;word-break: break-all;">${res['errmsg']}</strong>`, "提示", {
                        confirmButtonText: "确定",
                        dangerouslyUseHTMLString: true,
                        type: "error",
                        callback: (action) => {
                            me.RecordData = [];
                            me.queryClassStudent();
                        },
                    });
                }
            } else {
                this.$message({
                    type: "warning",
                    message: "请选择缴费班级",
                });
            }
        },

        async queryClassStudent () {
            let me = this;
            let param = me.query;
            this.RecordData = [];
            let res = await me.$team.queryClassStudent(param);
            if (res && res["success"]) {
                res.content.records.forEach(function (item, index) {
                    if (item.half && item.ageRemissionMoney) {
                        me.agediscount = true;
                    }
                    if (item.materialCost) {
                        me.ismast = true;
                    }
                    if (item.entryFee) {
                        me.isbm = true;
                    }
                    try {
                        const classRoomNames = item.classRoomNames.split(",");
                        const periodName = item.periodName.split(",");
                        let customClassName = "";
                        classRoomNames.forEach((item, index) => {
                            customClassName +=
                                classRoomNames[index] +
                                "：" +
                                periodName[index] +
                                (classRoomNames.length === index + 1
                                    ? ""
                                    : "；");
                        });
                        item.$customClassName = customClassName;
                    } catch (e) {
                        item.$customClassName = "";
                    }
                });
                let data = res.content.records;
                data.forEach(function (item, index) {
                    if (!item.submitOrder) {
                        item.ishalf = false;
                        me.RecordData.push(item);
                    }
                });
            }
        },
        //  当前页发生改变
        handleCurrentChange (page) {
            let me = this;
            me.pageIndex = page;
            me.queryClass();
        },

        //  每页显示条目个数发生改变
        handleSizeChange (e) {
            let me = this;
            me.pageIndex = page;
            me.queryClass();
        },
    },
};
</script>
<style lang="scss" >
#Grade {
    .el-tabs .el-tabs__content {
        padding: 0px 10px;
    }
    .el-table td {
        border-bottom: none;
    }
    .pay-tip {
        border: 1px solid #ffca85;
        display: flex;
        align-items: center;
        margin: 5px 0;
        padding: 10px 10px;
        background: rgba(255, 202, 133, 0.1);
        img {
            width: 35px;
            margin-right: 10px;
        }
        div {
            color: #ff8d3c;
            font-size: 14px;
        }
    }

    .table-footer {
        border: 1px solid #ebeef5;
        padding: 15px 10px;
        align-items: center;
        border-top: none;
        display: flex;
        justify-content: space-between;
        div {
            font-size: 16px;
            color: #0089e5;
        }
        .f-choose {
            cursor: pointer;
        }
        .f-footer {
            display: flex;
            align-items: center;
            div {
                color: #545b6d;
                margin: 0 10px;
                span {
                    color: #ff8d3c;
                }
            }
        }
    }
    .confirm-footer {
        display: block;
        overflow: hidden;
        padding-right: 30px;
        .f-footer {
            float: right;
            display: block;
            div {
                margin: 20px 0;
                span:first-child {
                    display: inline-block;
                    width: 200px;
                    color: #545b6d;
                    text-align: right;
                    margin-right: 20px;
                }
            }
            div:nth-child(2) {
                span:last-child {
                    font-weight: 700;
                    font-size: 20px;
                }
            }
        }
    }
    .payMoney {
        font-size: 16px;
        color: #545b6d;
        text-align: center;
        span {
            font-size: 30px;
            color: #ff8d3c;
        }
    }
    .el-button--default {
        border-color: #ebeef5;
        color: #333;
    }
    .el-button {
        border-radius: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pay/Grade/Grade.vue